export { default as isSharePointLink } from './isSharePointLink';
export { default as isSharePointServiceGeneratedLink } from './isSharePointServiceGeneratedLink';
